import { MessageCircle, Smartphone, Copy } from "lucide-react";
import { toast } from "sonner";
import { shareMessage, whatsappUrl, smsUrl, copyText } from "@/lib/share";

// Reusable warm share buttons. `accent` is an hsl tri:  e.g. '35 38% 45%'.
export default function ShareButtons({ type, name, url, accent = "35 38% 45%", compact = false, testidPrefix = "share" }) {
  const text = shareMessage(type, name, url);
  const size = compact ? "h-9 px-3 text-xs" : "h-11 px-4 text-sm";
  return (
    <div className="flex flex-wrap gap-2">
      <a data-testid={`${testidPrefix}-whatsapp`} href={whatsappUrl(text)} target="_blank" rel="noreferrer"
        className={`inline-flex items-center gap-2 rounded-xl font-semibold text-white ${size}`} style={{ background: "#25D366" }}>
        <MessageCircle size={compact ? 15 : 17} /> WhatsApp
      </a>
      <a data-testid={`${testidPrefix}-sms`} href={smsUrl(text)}
        className={`inline-flex items-center gap-2 rounded-xl font-semibold ${size} border border-[hsl(var(--border))] bg-[hsl(var(--card))] hover:bg-[hsl(var(--muted))] transition-colors`}>
        <Smartphone size={compact ? 15 : 17} /> Text / SMS
      </a>
      <button data-testid={`${testidPrefix}-copy`} onClick={async () => { (await copyText(url)) ? toast.success("Link copied") : toast.error("Could not copy"); }}
        className={`inline-flex items-center gap-2 rounded-xl font-semibold text-white ${size}`} style={{ background: `hsl(${accent})` }}>
        <Copy size={compact ? 15 : 17} /> Copy link
      </button>
    </div>
  );
}
